module.exports = __webpack_public_path__ + "static/media/arabe.9b3b1cd5.svg";